// extracted by mini-css-extract-plugin
export var editButton = "_ox-0";